import React from "react";
import { useNavigate } from "react-router-dom";

const SectionOne = (data) => {

  //To go on any other page
  const navigate=useNavigate();

  //To handle play games
  const handlePlayGames=()=>{
    data.data.forEach(e=>{
      if(e.category==='mostPlayed')
      {
        // console.log("selected ",e.game);
        localStorage.setItem("games",JSON.stringify(e.game));
        navigate("/seeAll");
      }
    })
  }

  return (
    <section className="slider-area slider-bg">
      <div className="contain">
        <div className="row justify-content-center">
          <div className="col-xl-9">
            <div className="slider-content text-center">
              <h6 className="wow fadeInDown" data-wow-delay=".2s">
                Games
              </h6>
              <h2 className="tlt fix" data-in-effect="fadeInLeft">
              GAMES<span>GALLERIA</span>
              </h2>
              <p className="wow fadeInUp" data-wow-delay="2s">
                FIND NEW GAMES BASED ON NEW TECHNOLOGY WHICH ARE FULL WITH FUN,
                ENTERTAINMENT AND KNOWLEDGE.
              </p>
              <span className="btn wow fadeInUp" data-wow-delay="2.2s"
                onClick={()=>{
                  handlePlayGames();
                }}>
                Play Games
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SectionOne;